import { render, staticRenderFns } from "./CommandBouncer.vue?vue&type=template&id=c07bc826&scoped=true&"
import script from "./CommandBouncer.vue?vue&type=script&lang=ts&"
export * from "./CommandBouncer.vue?vue&type=script&lang=ts&"
import style0 from "./CommandBouncer.vue?vue&type=style&index=0&id=c07bc826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07bc826",
  null
  
)

export default component.exports